import { Component } from 'react';
import BaseChart from 'legacy/javascripts/components/base_chart.es6';

class AdditionalQuestionScalar extends Component {
  render() {
    let options = {
      legend: { display: false },
      tooltips: { enabled: false },
      scales: {
        xAxes: [{ gridLines: { display: false } }],
        yAxes: [
          {
            ticks: { beginAtZero: true },
          },
        ],
      },
    };

    const extraParams = this.props.data.survey_question
      ? { survey_question_id: this.props.data.question_id }
      : { additional_question_id: this.props.data.question_id };

    return (
      <BaseChart
        type="bar"
        id="additionalQuestionScale"
        labels={this.props.data.labels}
        datasets={this.props.data.datasets}
        options={options}
        labelParam="additional_question_response_scalar"
        extraParams={extraParams}
        chartHandler={this.props.chartHandler}
      />
    );
  }
}

export default AdditionalQuestionScalar;
